import React, { useEffect, useMemo } from "react";
import WithFieldsCheck from "@isos/foundation/dist/Helpers/containers/WithFieldsCheck";
import "./index.css";
const shopifyScriptSrc = "https://cdn.shopify.com/storefront/web-components.js";
const storeDomain = "eshop.internationalsos.com";
const publicAccessToken = "202547e60058db448f4040d20edeb0d5";
const country = "GB";
const language = "en";
const Product = ({
  fields,
  rendering
}) => {
  const productHandle = fields?.ProductHandle?.value;
  const uniqueId = rendering?.uid?.replace(/[{}-]/g, "") || "default";
  const storeId = `shopify-store-${uniqueId}`;
  const cartId = `shopify-cart-${uniqueId}`;
  const qtyId = `quantity-${uniqueId}`;
  useEffect(() => {
    Object.keys(localStorage).forEach(key => {
      if (key.toLowerCase().includes("shopify")) {
        localStorage.removeItem(key);
      }
    });
    const existingScript = document.querySelector(`script[src="${shopifyScriptSrc}"]`);
    if (!existingScript) {
      const script = document.createElement("script");
      script.type = "module";
      script.src = shopifyScriptSrc;
      document.head.appendChild(script);
    }
    window.incrementQty = inputId => {
      const input = document.getElementById(inputId);
      if (!input) {
        return;
      }
      const currentValue = parseInt(input.value || "1");
      input.value = Number.isNaN(currentValue) ? 1 : currentValue + 1;
    };
    window.decrementQty = inputId => {
      const input = document.getElementById(inputId);
      if (!input) {
        return;
      }
      const currentValue = parseInt(input.value || "1");
      const nextValue = Number.isNaN(currentValue) ? 1 : Math.max(1, currentValue - 1);
      input.value = nextValue;
    };
    window.addProductToCart = (buttonEl, cartElementId, quantityInputId) => {
      const cart = document.getElementById(cartElementId);
      const qtyInput = document.getElementById(quantityInputId);
      if (!cart || !qtyInput || !buttonEl) {
        return;
      }
      const quantity = Math.max(1, Number(qtyInput.value) || 1);
      const variantId = buttonEl.dataset.variantId;
      if (!variantId) {
        return;
      }
      cart.addLine({
        variantId,
        quantity
      }).showModal();
    };
    return () => {
      delete window.incrementQty;
      delete window.decrementQty;
      delete window.addProductToCart;
    };
  }, []);
  const templateContent = useMemo(() => `
      <div class="product-card__container wrapper">
        <div class="product-card__media">
          <div class="product-card__main-image">
            <shopify-media
              layout="fixed"
              width="420"
              height="420"
              query="product.selectedOrFirstAvailableVariant.image">
            </shopify-media>
          </div>
        </div>
        <div class="product-card__details">
          <div class="product-card__info">
            <div class="product-card__vendor">
              <div class="product-card__vendor-text">
                <shopify-data query="product.vendor"></shopify-data>
              </div>
            </div>
            <h1 class="product-card__title">
              <shopify-data query="product.title"></shopify-data>
            </h1>
            <div class="product-card__price">
              <shopify-money query="product.selectedOrFirstAvailableVariant.price"></shopify-money>
              <shopify-money
                class="product-card__compare-price"
                query="product.selectedOrFirstAvailableVariant.compareAtPrice">
              </shopify-money>
            </div>
          </div>
          <div class="product-card__quantity">
            <label class="product-card__quantity-label" for="${qtyId}">
              Quantity
            </label>
            <div class="product-card__quantity-controls">
              <button
                type="button"
                class="product-card__qty-btn"
                onclick="window.decrementQty('${qtyId}')">
                -
              </button>
              <input
                id="${qtyId}"
                class="product-card__qty-input"
                type="number"
                min="1"
                value="1" />
              <button
                type="button"
                class="product-card__qty-btn"
                onclick="window.incrementQty('${qtyId}')">
                +
              </button>
            </div>
          </div>
          <div class="product-card__buttons">
            <button
              type="button"
              class="product-card__add-button"
              shopify-attr--data-variant-id="product.selectedOrFirstAvailableVariant.id"
              shopify-attr--disabled="!product.selectedOrFirstAvailableVariant.availableForSale"
              onclick="window.addProductToCart(this, '${cartId}', '${qtyId}')">
              Add to cart
            </button>
          </div>
          <div class="product-card__description">
            <span class="product-card__description-text">
              <shopify-data query="product.seo.description"></shopify-data>
            </span>
          </div>
        </div>
      </div>
    `, [cartId, qtyId, storeId]);
  if (!productHandle) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "shopify-product"
  }, /*#__PURE__*/React.createElement("shopify-store", {
    id: storeId,
    "public-access-token": publicAccessToken,
    "store-domain": storeDomain,
    country: country,
    language: language
  }, /*#__PURE__*/React.createElement("shopify-context", {
    type: "product",
    handle: productHandle
  }, /*#__PURE__*/React.createElement("template", {
    dangerouslySetInnerHTML: {
      __html: templateContent
    }
  })), /*#__PURE__*/React.createElement("shopify-cart", {
    id: cartId
  })));
};
export default WithFieldsCheck(Product);